import { render, staticRenderFns } from "./CommonFiltersPlace.vue?vue&type=template&id=2b0f64da&scoped=true&"
import script from "./CommonFiltersPlace.vue?vue&type=script&lang=js&"
export * from "./CommonFiltersPlace.vue?vue&type=script&lang=js&"
import style0 from "./CommonFiltersPlace.vue?vue&type=style&index=0&id=2b0f64da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f64da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0f64da')) {
      api.createRecord('2b0f64da', component.options)
    } else {
      api.reload('2b0f64da', component.options)
    }
    module.hot.accept("./CommonFiltersPlace.vue?vue&type=template&id=2b0f64da&scoped=true&", function () {
      api.rerender('2b0f64da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/desktop/CommonFilters/CommonFiltersPlace.vue"
export default component.exports